import { render, staticRenderFns } from "./GridForm.vue?vue&type=template&id=07433b56&scoped=true&"
import script from "./GridForm.vue?vue&type=script&lang=js&"
export * from "./GridForm.vue?vue&type=script&lang=js&"
import style0 from "./GridForm.vue?vue&type=style&index=0&id=07433b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07433b56",
  null
  
)

export default component.exports